import { createAction } from "@reduxjs/toolkit";
import {
  AddAdminActionType,
  AddRoomMembersActionType,
  AddRoomsActionType,
  DeleteRoomActionActionType,
  CLEAR_ROOMS,
  UPDATE_ROOM_MEMBER_RIGHTS,
  UPDATE_CHANNEL_ROOM_AVATAR,
  UPDATE_GROUP_ROOM_AVATAR,
  ADD_ROOMS,
  EDIT_ROOM,
  EDIT_ROOM_USERNAME,
  EDIT_ROOM_DESCRIPTION,
  EDIT_ROOM_EXTRA,
  REMOVE_ROOM,
  ADD_ROOM_MEMBERS,
  REMOVE_ROOM_MEMBER,
  REMOVE_ROOM_MEMBERS,
  ADD_ADMIN,
  KICK_ADMIN,
  SET_ROOM_ACTION,
  DELETE_ROOM_ACTION,
  SET_CURRENT_ROOM,
  UPDATE_CLIENT_MUTE_ROOM,
  SET_CURRENT_ROOM_EXTRA,
  UPDATE_ROOM_LAST_MESSAGE_STATUS,
  UPDATE_ROOM_LAST_MESSAGE,
  UPDATE_ROOM_STATUS,
  UPDATE_ROOM_COMPLETED,
  UPDATE_ROOM_READONLY,
  UPDATE_ROOM_MEMBER_LIST,
  EditRoomActionType,
  EditRoomDescriptionActionType,
  EditRoomExtra,
  EditRoomUsernameActionType,
  KickAdminActionType,
  RemoveRoomActionType,
  RemoveRoomMemberActionType,
  RemoveRoomMembersActionType,
  SetCurrentRoomActionType,
  SetCurrentRoomExtraType,
  SetRoomActionActionType,
  UpdateChannelRoomAvatarType,
  UpdateClientMuteRoomActionType,
  UpdateFetchRoomCompletedType,
  UpdateGroupRoomAvatarType,
  UpdateRoomLastMessage,
  UpdateRoomLastMessageStatus,
  UpdateRoomMemberList,
  UpdateRoomMemberRightsType,
  UpdateRoomReadOnlyType,
  UpdateRoomStatus,
  FilterRoomsActionType,
  FILTER_ROOMS,
} from "./types";

export const clearAllRooms = createAction(CLEAR_ROOMS);
export const updateRoomMemberRights = createAction<UpdateRoomMemberRightsType["payload"]>(UPDATE_ROOM_MEMBER_RIGHTS);
export const updateChannelAvatar = createAction<UpdateChannelRoomAvatarType["payload"]>(UPDATE_CHANNEL_ROOM_AVATAR);
export const updateGroupAvatar = createAction<UpdateGroupRoomAvatarType["payload"]>(UPDATE_GROUP_ROOM_AVATAR);
export const addRooms = createAction<AddRoomsActionType["payload"]>(ADD_ROOMS);
export const editRoom = createAction<EditRoomActionType["payload"]>(EDIT_ROOM);
export const editRoomUsername = createAction<EditRoomUsernameActionType["payload"]>(EDIT_ROOM_USERNAME);
export const editRoomDescription = createAction<EditRoomDescriptionActionType["payload"]>(EDIT_ROOM_DESCRIPTION);
export const editRoomExtra = createAction<EditRoomExtra["payload"]>(EDIT_ROOM_EXTRA);
export const removeRoom = createAction<RemoveRoomActionType["payload"]>(REMOVE_ROOM);
export const addRoomMembers = createAction<AddRoomMembersActionType["payload"]>(ADD_ROOM_MEMBERS);
export const removeRoomMember = createAction<RemoveRoomMemberActionType["payload"]>(REMOVE_ROOM_MEMBER);
export const removeRoomMembers = createAction<RemoveRoomMembersActionType["payload"]>(REMOVE_ROOM_MEMBERS);
export const addAdmin = createAction<AddAdminActionType["payload"]>(ADD_ADMIN);
export const kickAdmin = createAction<KickAdminActionType["payload"]>(KICK_ADMIN);
export const setRoomAction = createAction<SetRoomActionActionType["payload"]>(SET_ROOM_ACTION);
export const deleteRoomAction = createAction<DeleteRoomActionActionType["payload"]>(DELETE_ROOM_ACTION);
export const setCurrentRoom = createAction<SetCurrentRoomActionType["payload"]>(SET_CURRENT_ROOM);
export const updateClientMuteRoom = createAction<UpdateClientMuteRoomActionType["payload"]>(UPDATE_CLIENT_MUTE_ROOM);
export const setCurrentRoomExtra = createAction<SetCurrentRoomExtraType["payload"]>(SET_CURRENT_ROOM_EXTRA);
export const updateLastMessageStatus = createAction<UpdateRoomLastMessageStatus["payload"]>(UPDATE_ROOM_LAST_MESSAGE_STATUS);
export const updateLastMessage = createAction<UpdateRoomLastMessage["payload"]>(UPDATE_ROOM_LAST_MESSAGE);
export const updateRoomStatus = createAction<UpdateRoomStatus["payload"]>(UPDATE_ROOM_STATUS);
export const updateFetchRoomCompleted = createAction<UpdateFetchRoomCompletedType["payload"]>(UPDATE_ROOM_COMPLETED);
export const updateRoomReadOnly = createAction<UpdateRoomReadOnlyType["payload"]>(UPDATE_ROOM_READONLY);
export const updateRoomMemberList = createAction<UpdateRoomMemberList["payload"]>(UPDATE_ROOM_MEMBER_LIST);
export const filterRooms = createAction<FilterRoomsActionType["payload"]>(FILTER_ROOMS);
